import React from 'react';
import { connect } from 'react-redux';
// The sidebar menu icons come from the DB as fa-solid / fas class names, so
// Font Awesome 6+ has to be loaded for the whole app, not by a single screen.
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';
import Layout from './components/Shared/Layout';
import Login from './components/Authentication/login';
import SignUp from './components/Authentication/signup';
import Dashboard from './components/Authentication/signup';
import ForgotPassword from './components/Authentication/forgotpassword';
import NotFound from './components/Authentication/404';
import InternalServer from './components/Authentication/500';
import { PrivateRoute, PublicRoute } from "./components/RouteGuard";
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import useIdleLogout from "./hooks/useIdleLogout";


const App = ({ darkMode, boxLayout, darkSidebar, iconColor, gradientColor, rtl, fontType }) => {
	
	 // 🔥 ADD THIS LINE
  useIdleLogout(); // default 30 minutes
	
	return (
		<div className={`${darkMode ? "dark-mode" : ""}${darkSidebar ? "sidebar_dark" : ""} ${iconColor ? "iconcolor" : ""} ${gradientColor ? "gradient" : ""} ${rtl ? "rtl" : ""} ${fontType ? fontType : ""}${boxLayout ? "boxlayout" : ""}`}>
			<Router>
				<Switch>
					{/* Redirect root path to login */}
					<Route exact path="/">
						<Redirect to="/login" />
					</Route>

					{/* Public Routes */}
					<Route
						path="/signup"
						render={() => (
							<PublicRoute>
								<SignUp />
							</PublicRoute>
						)}
					/>
					<Route
						path="/login"
						render={() => (
							<PublicRoute>
								<Login />
							</PublicRoute>
						)}
					/>
					<Route
						path="/forgotpassword"
						render={() => (
							<PublicRoute>
								<ForgotPassword />
							</PublicRoute>
						)}
					/>
					<Route
						path="/notfound"
						render={() => (
							<PublicRoute>
								<NotFound />
							</PublicRoute>
						)}
					/>
					<Route
						path="/internalserver"
						render={() => (
							<PublicRoute>
								<InternalServer />
							</PublicRoute>
						)}
					/>

					{/* Private Route */}

					<Route

						component={Layout}
					/>
				</Switch>
			</Router>
		</div>
	);
};

const mapStateToProps = (state) => ({
	darkMode: state.settings.isDarkMode,
	darkSidebar: state.settings.isDarkSidebar,
	iconColor: state.settings.isIconColor,
	gradientColor: state.settings.isGradientColor,
	rtl: state.settings.isRtl,
	fontType: state.settings.isFont,
	boxLayout: state.settings.isBoxLayout,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(App);
